import { createLogger } from '../../../app/logger'
import useAppDispatch from '../../../hooks/useAppDispatch'
import useAppSelector from '../../../hooks/useAppSelector'
import { markRequestsSynced } from '../dataSlice'
import { getOnlineSelector } from '../../network/networkSlice'
import { useEffect, useRef } from 'react'
import { useUnsyncedUpdates } from './useUnsyncedUpdates'
import { useEventId } from '../../../app/location'
import { getKioskIdSelector } from '../../session/sessionSlice'
import { useUpdateEntriesMutation } from '../../../api/ctliveApi'
import LocalForage from '../../../app/localForage'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'useSyncChanges'
})

/**
 * This is a void hook that is called to check network status and push unsynced changes as needed and able
 */
export const useSyncChanges = () => {
  const dispatch = useAppDispatch()
  const eventId = useEventId()
  const kioskId = useAppSelector(getKioskIdSelector)
  const online = useAppSelector(getOnlineSelector)
  const unsyncedUpdates = useUnsyncedUpdates()
  const username = useAppSelector(state => state.session.username)
  const [updateEntries] = useUpdateEntriesMutation()
  const isSyncingRef = useRef(false)
  const version = process.env.REACT_APP_VERSION

  useEffect(() => {
    const handle = setInterval(() => {
      if (online && unsyncedUpdates.length && !isSyncingRef.current) {
        isSyncingRef.current = true

        updateEntries({
          entries: unsyncedUpdates,
          eventId,
          kioskId,
          username
        })
          .unwrap()
          .catch((err) => console.error(err, 'error while updatingEntries'))
          .then((data) => {
            if (data?.updatedEntries?.length) {
              dispatch(markRequestsSynced(data.updatedEntries))
              LocalForage.instance().remove('unsyncedChanges', eventId)
                .then(() => {
                  logger.info(`pickUp unsyncedChanges table cleared successfully for event: ${eventId}`)
                })
            }
          })
          .finally(() => {
            isSyncingRef.current = false
          })
      }
    }, 3000)
    return () => clearInterval(handle)
  }, [
    dispatch,
    eventId,
    kioskId,
    online,
    unsyncedUpdates,
    updateEntries,
    username,
    version,
  ])
}
